// @flow
import { RedesActionTypes } from './constants';

type RedesAction = { type: string, payload: {} | string };

// common success
export const redesApiResponseSuccess = (actionType: string, data: any): RedesAction => ({
    type: RedesActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const redesApiResponseError = (actionType: string, error: string): RedesAction => ({
    type: RedesActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getRed = (id: string): RedesAction => ({
    type: RedesActionTypes.GET_RED,
    payload: { id },
});

export const addRed = (red:any):RedesAction=>({
    type:RedesActionTypes.ADD_RED,
    payload:red
})
export const updateRed = (red:any):RedesAction=>({
    type:RedesActionTypes.UPDATE_RED,
    payload:red
})
export const deleteRed = (id:string):RedesAction=>({
    type:RedesActionTypes.DELETE_RED,
    payload:{id}
})

export const listRedes = (params:any): RedesAction => ({
    type: RedesActionTypes.LIST_REDES,
    payload: params,
});


export const resetRedes = (): RedesAction => ({
    type: RedesActionTypes.RESET,
    payload: {},
});

